// extracted by mini-css-extract-plugin
export default {"item":"PrevPage_item__0R+0f","link":"PrevPage_link__jAIJi"};